import { httpRequest } from "../../http"

export class CommandUpdateEngagementName {
  async run(engagementId: number, newEngagementName: string) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/`
    try {
      const response = await httpRequest<any>(url, {
        method: "PATCH",
        body: {
          name: newEngagementName,
        },
      })

      return response
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }
}
